module.exports = __webpack_public_path__ + "img/drawshapes.aeb5ef86.jpg";